'use client';

import {
  GoogleReviewAsideModal,
  useOpenGoogleReviewModal,
} from '@hyphengroup/cms-components/components/GoogleReview';
import { usePageDataContext } from '$/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import { pushDataLayer } from '$/components/cms/pushDataLayer';

type GoogleReviewModalContainerProps = {
  /**
   * Page slug, reported as the drawer's `item_list_name`. Required so a new call
   * site cannot omit it and silently drop the parameter from the events.
   */
  slug: string | undefined;
};

/**
 * Single Google reviews drawer for the whole page/article. Renders once at the
 * content level (see PageContent / ArticleContent) instead of one modal per
 * product card.
 *
 * The open product is driven by the `googleReviewProductId` URL hash; the
 * product itself is resolved from `pageData.googleReviewProducts`, collected
 * server-side in `GetGoogleReviewProductsIfNeeded`.
 */
export const GoogleReviewModalContainer: React.FC<
  GoogleReviewModalContainerProps
> = ({ slug }) => {
  const { pageData } = usePageDataContext();
  const { googleReviewProductId, closeModal } = useOpenGoogleReviewModal();

  const product = pageData.googleReviewProducts?.find(
    (p) => p.uid === googleReviewProductId,
  );

  if (!product) {
    return null;
  }

  return (
    <GoogleReviewAsideModal
      product={product}
      isOpen
      onClose={() => closeModal()}
      pushDataLayer={pushDataLayer}
      itemListName={slug}
    />
  );
};
